module.exports = new __parcel__URL__("chest.a00a5c4b.webp").toString();